export const resourcemgmtcolumnsForExport = [
  // { label: "Name", key: "name" },
  { label: "Resource Name", key: "resource_name" },
  { label: "Resource Activity", key: "rsrc_activity_id" },
  { label: "Resource Category", key: "rsrc_cat_id" },
  { label: "Total Quantity (including out of service/Damaged Quantity)", key: "total_quantity" },
  { label: "Out of service/Damaged Quantity", key: "damaged_quantity" },
  { label: "Deployed Quantity", key: "deploy_quantity" },
  {label: "Available Quantity", key: "available_quantity"},
  { label: "Stock Status", key: "stockStatus" },
  { label: "Agency Name", key: "agency_name" },
  { label: "District", key: "dist_name" },
  { label: "Block", key: "region_name" },
  { label: "Description", key: "description" },
  { label: "Facility", key: "facility" },
  { label: "Agency Contact", key: "contact_info" },
  {label: "Created on", key: "created_on"},
  {label: "Created By", key: "created_by"},
  {label: "Updated By", key: "updated_by"},
  {label: "Updated On", key: "updated_on"},
  { label: "Deployed", key: "is_deployed" },
  { label: "Status", key: "status" },
];
